import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import nityNiyamReducer from "./slice/audioSlice";
import blogReducer from "./slice/blogSlice";
import calendarReducer from "./slice/calendarSlice";
import headerReducer from "./slice/headerSlice";
import imageGalleryReducer from "./slice/ImageGallerySlice";
import kirtanLyricsReducer from "./slice/kirtanLyricsSlice";
import loginReducer from "./slice/loginSlice";
import titleReducer from "./slice/titleSlice";
import youtubeVideoReducer from "./slice/youtubePlayerSlice";
import recipeReducers from "./slice/recipeSlice";
import familyReducer from "./slice/myFamilySlice";
import thalbhetReducer from "./slice/thalbhetSlice";
import satsangQuiz from "./slice/satsangQuizSlice";
import location from "./slice/locationSlice";
import profile from "./slice/profileSlice";
import search from "./slice/searchSlice";
import dhyanMurti from "./slice/dhyanMurtiSlice";
import contactReducer from "./slice/contactSlice";
import settingReducer from "./slice/settingSlice";

export const myStore = configureStore({
  reducer: {
    header: headerReducer,
    imageGalleryData: imageGalleryReducer,
    blog: blogReducer,
    calendar: calendarReducer,
    nityNiyam: nityNiyamReducer,
    title: titleReducer,
    youtubeVideo: youtubeVideoReducer,
    kirtanLyrics: kirtanLyricsReducer,
    login: loginReducer,
    recipe: recipeReducers,
    myFamily: familyReducer,
    thalbhet: thalbhetReducer,
    satsangQuiz: satsangQuiz,
    location: location,
    profile: profile,
    search: search,
    dhyanMurti: dhyanMurti,
    contact: contactReducer,
    setting: settingReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof myStore.getState>;
export type AppDispatch = typeof myStore.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
